import { render } from "./NewReservation.vue?vue&type=template&id=3fda3a08&scoped=true"
import script from "./NewReservation.vue?vue&type=script&lang=js"
export * from "./NewReservation.vue?vue&type=script&lang=js"

import "./NewReservation.vue?vue&type=style&index=0&id=3fda3a08&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fda3a08"]])

export default __exports__